import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ProvidersDesktopPage } from './providers-desktop.page';

const routes: Routes = [
  {
    path: '',
    component: ProvidersDesktopPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProvidersDesktopPageRoutingModule {}
